import { useEffect } from 'react';

export default function SEO({ title, description }) {
  useEffect(() => {
    const companyName = "Tømrermester Mikkel Juler ApS";
    
    // Sæt sidetitel ud fra reglerne
    if (title === "Forside" || !title) {
      document.title = companyName;
    } else {
      document.title = `${title} - ${companyName}`;
    }

    // Sæt metabeskrivelse
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    
    const defaultDesc = "Tømrermester Mikkel Juler ApS i Egtved og omegn tilbyder professionelt tømrerarbejde i høj kvalitet. Vi udfører nyt tag, træterrasser, tilbygninger, renovering samt døre og vinduer.";
    metaDesc.setAttribute('content', description || defaultDesc);
  }, [title, description]);

  return null;
}
